module.exports = __webpack_public_path__ + "img/medal_gold.56c9c873.svg";